import { inkBackgroundTokens } from '@ds/tokens'

const tokens = {
  opacityLevel: 0.9,
  defaultBackgroundColor: inkBackgroundTokens.bgColorDefault,
} as const

export default tokens
